import FullSite from "./full-site";
import { LiveTemplate } from "../../jamibet/desktop-pages/live";

export default function Live(props) {
	return <FullSite><LiveTemplate {...props} /></FullSite>;
}
